(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  /**
   * Video status
   * Used in select locations where there needs to be placeholder content
   * in pace before a video loads. Used mainly for large videos or headers.
   * Also, this only applies to tablets and desktop - no effects to mobile.
   **/

  let display_video = function() {
    let video_section = document.querySelector('#video-overlay');
    if (!video_section) return;

    let video = document.querySelector('#video-overlay video'),
        video_parent = document.querySelector('.video-wrapper'),
        video_text = document.querySelector('.video-text');

    let promise = video.play();

    if (promise !== undefined) {
      promise.then(_ => {
        // Autoplay is either enabled, or started
        if (video_section.classList.contains('centered')) {

          // it is expected that the blur-video class is added in the CMS!!
          // expected call, at least for first-time encounters
          video.addEventListener('canplaythrough', (event) => {
            video_text.classList.add('hide-text');
            video_parent.classList.remove('blur-video');
          });

          // expected call when video ends
          video.addEventListener('ended', (event) => {
            video_text.classList.remove('hide-text');
            video_parent.classList.add('blur-video');
          });

        } else {

          // expected call, at least for first-time encounters
          video.addEventListener('canplaythrough', (event) => {
            video_text.classList.add('hide-text');
          });

          // expected call when video ends
          video.addEventListener('ended', (event) => {
            video_text.classList.remove('hide-text');
          });
        }
      }).catch(error => {
        // do nothing - text stays where it is
      });
    }

  };
  display_video();

}));
